module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/design-tile-images/design-tile-11-0e3ae5cbfd71ced863150cab4d8d4f88.png";